/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type NeoletterUserProfileFragment = {
  __typename: "NeoletterUserProfile"
  id: string
  name?: string | null
  salutation?: string | null
  given_name?: string | null
  family_name?: string | null
  email?: string | null
  position?: string | null
  staff?: boolean | null
  phone_number?: string | null
  company?: string | null
  custom_fields?: {
    __typename: "NeoletterUserProfileCustomFields"
    active_project_id?: string | null
    sidebar_is_expanded?: string | null
  } | null
}

export const NeoletterUserProfileFragmentDoc = gql`
  fragment NeoletterUserProfile on NeoletterUserProfile {
    id
    name
    salutation
    given_name
    family_name
    email
    position
    staff
    phone_number
    company
    custom_fields @type(name: "NeoletterUserProfileCustomFields") {
      active_project_id
      sidebar_is_expanded
    }
  }
`
